document.addEventListener("DOMContentLoaded", function () {
  const paragraphs = document.querySelectorAll(".one-whole.column.content p");

  for (let i = 0; i < paragraphs.length - 1; i++) {
    const currentParagraph = paragraphs[i];
    const nextParagraph = paragraphs[i + 1];

    const currentImages = currentParagraph.querySelectorAll("img");
    const nextImages = nextParagraph.querySelectorAll("img");

    if (currentImages.length > 0 && nextImages.length > 0) {
      const wrapper = document.createElement("div");
      wrapper.classList.add("img-wrapper");

      currentImages.forEach(img => wrapper.appendChild(img));
      nextImages.forEach(img => wrapper.appendChild(img));

      currentParagraph.innerHTML = "";
      currentParagraph.appendChild(wrapper);
      nextParagraph.remove();
      i++;
    }
  }
});
